import { getStorageUserId } from 'utils/storage';
import { sendDataLayerError } from 'utils/TagManager';

export const onSubmitEventTagHandler = (
    errors: any,
    label: string,
    stage?: string,
) => {
    const UID = getStorageUserId();

    for (const field_name in errors) {
        if (errors[field_name]) {
            const field_error = errors[field_name] as any;
            
            stage && sendDataLayerError(label, stage, UID, field_name, field_error);
        }
    }
};
